import railsAxios from '../lib/railsAxios';

const cache = {};

async function uniqueEmail(value) {
  if (!value) {
    return true;
  }
  const cacheKey = value;
  if (cache[cacheKey] === undefined) {
    try {
      const response = await railsAxios.get('/api/email-status', { params: { email: value } });
      const exists = response.data.data;
      if (!exists) {
        cache[cacheKey] = true;
      } else {
        cache[cacheKey] = false;
      }
      return cache[cacheKey];
    } catch (error) {
      // Data from call not required
      // No need to flash error message here
      // Logging happens in railsAxios
      return true;
    }
  } else {
    return cache[cacheKey];
  }
}

export default uniqueEmail;
